














import { Component, Vue } from "vue-property-decorator";

@Component({ inheritAttrs: false })
export default class BaseInput extends Vue {
  private get listeners() {
    return {
      ...this.$listeners
    };
  }

  public get elm(): HTMLInputElement {
    return this.$refs.component as HTMLInputElement;
  }

  public focus() {
    this.elm.focus();
  }

  public get value() {
    return this.elm.value;
  }

  public blur() {
    window.console.log("blur");
    this.elm.blur();
  }

  public getBoundingClientRect(): ClientRect | DOMRect {
    return this.elm.getBoundingClientRect();
  }
}
